var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgUserBag(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M4 6.5c1.654 0 3-1.346 3-3 0-1.655-1.346-3-3-3-1.655 0-3 1.345-3 3 0 1.654 1.345 3 3 3zm0-5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm.995 6.605a.5.5 0 01-.566.425A3.003 3.003 0 001 11.5v.5a.5.5 0 01-.999 0v-.5a4.005 4.005 0 014.57-3.96.5.5 0 01.425.566zM11 7.525v-.026c0-1.103-.897-2-2-2s-2 .897-2 2v.026c-.57.116-1 .621-1 1.224v1.75c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2V8.75c0-.603-.43-1.108-1-1.224zM9 6.499c.552 0 1 .449 1 1H8c0-.551.448-1 1-1zm2 4c0 .552-.448 1-1 1H8c-.551 0-1-.448-1-1V8.75a.25.25 0 01.25-.25h3.5a.25.25 0 01.25.25v1.75z",
    fill: "#fff"
  })));
}
export default SvgUserBag;